export default __webpack_public_path__ + "static/media/people-primary.5a1ac4ed.svg";